/**
 * Initialisiert {@link v3sWbtPlayerApp:exercise.service_v3sFeedbackService v3sFeedbackService}
 * @class directive_v3sFeedbacks
 * @memberOf v3sWbtPlayerApp:exercise
 */
angular.module('v3sWbtPlayerApp').directive('v3sFeedbacks', ['v3sFeedbackService', function (v3sFeedbackService) {
    return {
        require: ['^v3sDocument'],
        restrict: 'E',
        compile: function compile(element) {

            var processedFeedbackBlocks = [[], []];
            var tries = element.find("v3s-feedback-block").length;

            angular.forEach(element.children(), function (node, index) {
                var tagName = node.tagName.toLowerCase();
                var innerText = node.textContent;

                if (tagName == "v3s-summary") {
                    v3sFeedbackService.setSummary(node.innerHTML);
                } else if (tagName == "v3s-feedback-block") {
                    var ngFbblock = angular.element(node);
                    var thetry = ngFbblock.attr('v3s-try');
                    var feedbacks = ngFbblock.find('v3s-feedback');
                    angular.forEach(feedbacks, function (fb) {
                        var ngFb = angular.element(fb);
                        var text = ngFb.html();
                        var audio = ngFb.attr('v3s-audio-ref');
                        if (!!text || !!audio) {//There are empty feedbackblocks...
                            var context = ngFb.attr('v3s-context').toLowerCase();
                            var block = { text: text, audio: audio };
                            //Wenn es nur einen Versuch gibt, schreiben wir immer in das letzte Feedback array...
                            if (!!tries && tries === 1) {
                                processedFeedbackBlocks[1][context] = block;
                            } else {
                                processedFeedbackBlocks[thetry - 1][context] = block;
                            }
                        }
                    });

                }
            });

            v3sFeedbackService.setFeedbackBlock(processedFeedbackBlocks);
            element.html("");

            return function (scope, element, attributes, controls) {
                var v3sDocumentCtrl = controls[0];

                v3sFeedbackService.setFeedbackScope(scope);

                scope.$on('$destroy', function () { //TODO NEW!!!
                    v3sFeedbackService.setFeedbackBlock([[], []]);
                    v3sFeedbackService.setSummary(null);
                });

                // Annotieren ermöglichen
                var feedbacksElement = angular.element(document.getElementById("feedbacks"));
                v3sDocumentCtrl.addElement(feedbacksElement, {
                    show: v3sFeedbackService.showAllFeedbacks,
                    hide: v3sFeedbackService.hideFeedback,
                    isShown: v3sFeedbackService.isShown
                });
            }
        }
    }
}]);